import React from "react";
import Modal from "../../../../elements/Modal";
import ManageCategory from "../ManageCategory";

const ManageCategoryModal = ({
  open,
  close = () => { },
  getResponse = () => { },
  data = {},
  type
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="md"
      title={data?._id ? "Update One" : "Create New"}
    >
      <ManageCategory getResponse={getResponse} close={close} data={data} type={type} />
    </Modal>
  );
};

export default ManageCategoryModal;
